// @flow

import styled, { css } from 'styled-components';
import type { Theme } from '../../../types';
import type { ColorScheme } from '../../../types/theme';
import type { BorderType } from '../types';
import {
  SCHEME_DEFAULT,
  SCHEME_DEFAULT_LIGHT,
  BORDER_HERO,
  BORDER_OUTLINE,
  BORDER_BORDER,
  BORDER_SHADOW,
  BORDER_FILL,
  BORDER_NONE,
} from '../constants';

type Props = {
  border: BorderType,
  scheme: ColorScheme,
  minimalistic: boolean,
  schemeName: string,
};

const getBoxProperties = ({
  border,
  scheme,
  minimalistic,
  schemeName,
}: Props) => {
  // default and default light schemes do not have a background color and therefore
  // do not need padding or shadows.
  if (
    schemeName === SCHEME_DEFAULT
    || schemeName === SCHEME_DEFAULT_LIGHT
    || border === BORDER_HERO
  ) {
    return '';
  }

  switch (border) {
    case BORDER_BORDER:
    case BORDER_OUTLINE:
      return css`
        background: ${scheme.background};
        border: 1px solid ${scheme.border};
        padding: ${minimalistic ? '1.35rem' : '1.5rem'};
      `;
    case BORDER_SHADOW:
      return css`
        background: ${scheme.background};
        border: none;
        box-shadow: ${scheme.shadow};
        padding: ${minimalistic ? '1.35rem' : '1.5rem'};
      `;
    case BORDER_NONE:
    case BORDER_FILL:
    default:
      return css`
        background: ${scheme.background};
        border: none;
        padding: ${minimalistic ? '1.35rem' : '1.5rem'};
      `;
  }
};
const ListContainer = styled<any, Theme, Props>('article')`
  border-radius: ${({ theme }) => theme.list.borderRadius};
  color: ${props => props.scheme.text};
  ${props => getBoxProperties(props)}
`;

export default ListContainer;
